<template>
    <div class="Index-head-bigDiv">
        <el-row style="background: #E8EFF7;padding: 20px">
            <el-col :span="6">
                <el-card class="box-card Introduce-left">
                    <el-divider content-position="left" class="cursor"><span
                            style="font-size: 20px">{{leftData.prName}}</span></el-divider>
                    <p class="cursor" v-for="(item,index) in leftData.role_dic2"
                       :key="index" @click="LeftClick(item)">
                        {{item.name}}</p>
                </el-card>
            </el-col>
            <el-col :span="18">
                <el-card v-if="!bottomClickData" class="box-card Introduce-right">
                    <el-divider content-position="left" class="cursor"><span
                            style="font-size: 19px">{{leftClickData.name}}</span></el-divider>
                    <ul style="max-height: 520px;overflow: auto">
                        <div v-for="(item,index) in rightData" :key="'right'+index" @click="RightClick(item,index)">
                            <div v-if="(item.catalogId !== item.operationId)">
                                <div style="margin-top:10px" v-if="item.newsIamges">
                                    <el-row>
                                        <el-col :span="4">
                                            <el-image
                                                    style="max-width: 100px;max-height: 100px"
                                                    :src="BasePath + item.newsIamges"
                                                    :preview-src-list="[BasePath + item.newsIamges]">
                                            </el-image>
                                        </el-col>
                                        <el-col :span="16">
                                            <p class="cursor Introduce-right-p certificateLi">{{item.newsTitle}}</p>
                                        </el-col>
                                        <el-col :span="4" style="text-align: right">
                                            <span class="cursor">{{item.newsDate}}</span>
                                        </el-col>
                                    </el-row>
                                </div>
                                <div style="margin-top:10px" v-if="!item.newsIamges">
                                    <el-col :span="20">
                                        <p class="cursor Introduce-right-p certificateLi" style="margin-left: 0;">
                                            {{item.newsTitle}}</p>
                                    </el-col>
                                    <el-col :span="4" style="text-align: right">
                                        <p class="cursor">{{item.newsDate}}</p>
                                    </el-col>
                                </div>
                            </div>
                        </div>
                    </ul>
                    <div style="width: 100%;text-align: center">
                        <el-pagination
                                @size-change="getRightDatapagination"
                                @current-change="getRightDatapagination"
                                :current-page.sync="pagination.currentPage"
                                :page-sizes="pagination.pagesizes"
                                :page-size.sync="pagination.pagesize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total.sync="pagination.total">
                        </el-pagination>
                    </div>
                </el-card>
                <el-card v-if="bottomClickData" class="box-card Introduce-right">
                    <el-col :span="8">
                        <el-divider content-position="left" class="cursor">
                            <span style="font-size: 19px" @click="ClickTofather">{{leftClickData.name}}</span>
                        </el-divider>
                    </el-col>
                    <el-col :span="16">
                        <el-divider content-position="left" class="cursor">
                            <span class="certificateLi" style="font-size: 18px">{{bottomClickData.newsTitle}}</span>
                        </el-divider>
                    </el-col>
                    <div style="width: 100%;overflow:auto;">
                        <div style="width: 750px;margin-right: auto;margin-left: auto" id="html"
                             v-html="bottomClickData.newsContent"/>
                        <div style="width: 750px;margin-right: auto;margin-left: auto">
                            <el-col :span="12" style="text-align: left" class="cursor">
                                <div @click="BrotherBottomClick(0)" style="width: 90%;" class="certificateLi">
                                    {{brotherBottomClickData[0] ? ((brotherBottomClickData[0].catalogId !==
                                    brotherBottomClickData[0].operationId) ? brotherBottomClickData[0].newsTitle :
                                    "暂无上一篇") : "暂无上一篇"}}
                                </div>
                            </el-col>
                            <el-col :span="12" style="text-align: right" class="cursor">
                                <div @click="BrotherBottomClick(1)" style="width: 90%;margin-left: 10%"
                                     class="certificateLi">
                                    {{brotherBottomClickData[1] ? ((brotherBottomClickData[1].catalogId !==
                                    brotherBottomClickData[1].operationId) ? brotherBottomClickData[1].newsTitle :
                                    "暂无下一篇") : "暂无下一篇"}}
                                </div>
                            </el-col>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <div style="text-align: center;width: 100%;height: 110px;background: rgb(219,219,219);margin-top: 20px">
            <h2 class="cursor" style="margin-top: 20px;float: left;width: 100%">固基行远,协晨悟通</h2>
            <div class="bottom">
                <span class="bottom-span cursor">技术支持：固远晨通科技发展有限公司</span>
            </div>
            <div class="bottom">
                <span class="bottom-span cursor">邮箱：GuYuanChenTong@126.com</span>
            </div>
            <div class="bottom">
                <span class="bottom-span cursor">ICP备案号：蜀ICP备16018349号-3</span>
            </div>
            <div class="bottom">
                <span class="bottom-span cursor"><a target="_blank" href="http://www.kuaidi.com/">快递查询API</a></span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Introduce",
        data() {
            return {
                leftData: {},
                rightData: {},
                leftClickData: {},
                bottomClickData: null,
                brotherBottomClickData: [null, null],
                brotherBottomClickIndex: 0,
                //分页数据绑定
                pagination: {
                    currentPage: 1,
                    pagesizes: [10, 20, 30, 40, 50],
                    pagesize: 10,
                    total: 0
                },
                loadding: null
            }
        },
        async created() {
            console.log(this.$route.query)
            this.loadding = this.openLoading();
            await this.$http.post('InformationAnnouncement/NewsConttable', {
                id: +this.$route.query.catalogId,
                Sel: "",
            }).then(res => {
                this.leftData = res.data;
                this.leftClickData = res.data;
            }).catch(() => {
                this.$message.error('服务器异常,请联系管理员!')
            })
            await this.getRightData(true);
            document.getElementsByTagName("html")[0].scrollTop = 700;
            loadding.close();
        },
        updated() {
            if (this.loadding) {
                this.loadding.close();
            }
        },
        methods: {
            // 点击左边的p标签
            LeftClick(item) {
                this.$router.push({
                    path: "/Introduce", query: {
                        catalogId: item.id,
                        id: null,
                        currentPage: this.pagination.currentPage,
                        pagesize: this.pagination.pagesize,
                    }
                })
                location.reload();
            },
            // 点击右边的数据
            RightClick(item, index) {
                this.$router.push({
                    path: "/Introduce", query: {
                        catalogId: item.catalogId, id: item.id,
                        currentPage: this.pagination.currentPage,
                        pagesize: this.pagination.pagesize,
                    }
                })
                location.reload();
            },
            // 点击上一篇或者下一篇
            BrotherBottomClick(index) {
                if (this.brotherBottomClickData[index]) {
                    if (this.brotherBottomClickData[index].catalogId !== this.brotherBottomClickData[index].operationId) {
                        let dataIndex = index === 0 ? this.brotherBottomClickIndex - 1 : this.brotherBottomClickIndex + 1;
                        this.$router.push({
                            path: "/Introduce",
                            query: {
                                catalogId: this.rightData[dataIndex].catalogId,
                                id: this.rightData[dataIndex].id,
                                currentPage: this.pagination.currentPage,
                                pagesize: this.pagination.pagesize,
                            }
                        })
                        location.reload();
                    }
                    // console.log(this.rightData[dataIndex]);
                    // return;
                    // this.RightClick(this.rightData[dataIndex],dataIndex)
                    // document.getElementsByTagName("html")[0].scrollTop = 700;
                }
            },
            // 点击分页
            getRightDatapagination() {
                this.$route.query.currentPage = this.pagination.currentPage;
                this.$route.query.pagesize = this.pagination.pagesize;
                this.getRightData(false);
            },
            // 获取右边表格数据
            async getRightData(idFalse) {
                await this.$http.post('InformationAnnouncement/GetNews', {
                    currentPage: this.$route.query.currentPage ? this.$route.query.currentPage : this.pagination.currentPage,
                    pagesize: this.$route.query.pagesize ? this.$route.query.pagesize : this.pagination.pagesize,
                    CatalogId: this.leftClickData.id,
                    Sel: "",
                    StartDate: "",
                    EndDate: ""
                }).then(res => {
                    this.pagination.total = res.data.count;
                    this.rightData = res.data.data;
                    this.bottomClickData = null;
                    if (res.data.data.length === 1) {
                        this.bottomClickData = res.data.data[0];
                    } else {
                        if (res.data.data.length === 2) {
                            let isCatalogId = -1;
                            for (let l = 0; l < res.data.data.length; l++) {
                                if (res.data.data[l].catalogId === res.data.data[l].operationId) {
                                    isCatalogId = l === 1 ? 0 : 1;
                                    break;
                                }
                            }
                            if (isCatalogId >= 0) {
                                this.bottomClickData = res.data.data[isCatalogId];
                                return;
                            }
                        }
                        if (idFalse) {
                            for (let i = 0; i < res.data.data.length; i++) {
                                if ((res.data.data[i].catalogId === res.data.data[i].operationId)) {
                                    this.pagination.total -= 1;
                                }
                                if (res.data.data[i].id === +this.$route.query.id) {
                                    this.bottomClickData = res.data.data[i];
                                    this.brotherBottomClickIndex = i;
                                    if (res.data.data[i - 1]) {
                                        this.brotherBottomClickData[0] = res.data.data[i - 1]
                                    } else {
                                        this.brotherBottomClickData[0] = null
                                    }
                                    if (res.data.data[i + 1]) {
                                        this.brotherBottomClickData[1] = res.data.data[i + 1]
                                    } else {
                                        this.brotherBottomClickData[1] = null
                                    }
                                    break;
                                }
                            }
                        }
                    }
                }).catch(() => {
                    this.$message.error('服务器异常,请联系管理员!')
                })
            },
            // 点击返回父元素
            ClickTofather() {
                this.$router.push({path: "/Introduce", query: {catalogId: this.leftClickData.id, id: null}})
                location.reload();
            },
        }
    }
</script>

<style scoped>
    .Introduce-left {
        width: 100%;
        height: 100%;
    }

    .Introduce-right {
        width: 98%;
        margin-left: 2%;
    }

    .Introduce-bottom {
        width: 100%;
        height: 600px;
        margin-top: 20px;
    }

    .Introduce-left p {
        margin-left: 40px;
        font-size: 16px;
    }

    .Introduce-left p:hover {
        color: #1961AC;
        font-size: 18px;
    }

    .Introduce-right-p {
        margin-left: 10px;
        font-size: 16px;
    }

    .Introduce-right-p:hover {
        color: #1961AC;
        font-size: 17px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Introduce.vue